import ApiService from './api.service';

class ActivityService {
  async list() {
    try {
      const response = await ApiService.get('/activity');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(data) {
    try {
      const response = await ApiService.post('/activity/add', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const response = await ApiService.put('/activity/update', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(id) {
    try {
      const response = await ApiService.delete('/activity/delete', { id });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new ActivityService(); 